export const usDHS = [
  { itemValue: 'DESIGNATED', itemLabel: 'DESIGNATED' },
  { itemValue: 'lANDING RIGHTS', itemLabel: 'lANDING RIGHTS' },
  { itemValue: 'USER FEE', itemLabel: 'USER FEE' },
  { itemValue: 'UNDEFINED', itemLabel: 'UNDEFINED' },
];

export const HRS_24 = '24_HRS';
export const ON_REQUEST = 'ON_REQUEST';

export const DEFAULT_HRS = {
  'arrival-from-friday': '',
  'arrival-from-monday': '',
  'arrival-from-saturday': '',
  'arrival-from-sunday': '',
  'arrival-from-thursday': '',
  'arrival-from-tuesday': '',
  'arrival-from-wednesday': '',
  'arrival-to-friday': '',
  'arrival-to-monday': '',
  'arrival-to-saturday': '',
  'arrival-to-sunday': '',
  'arrival-to-thursday': '',
  'arrival-to-tuesday': '',
  'arrival-to-wednesday': '',
  'departures-from-friday': '',
  'departures-from-monday': '',
  'departures-from-saturday': '',
  'departures-from-sunday': '',
  'departures-from-thursday': '',
  'departures-from-tuesday': '',
  'departures-from-wednesday': '',
  'departures-to-friday': '',
  'departures-to-monday': '',
  'departures-to-saturday': '',
  'departures-to-sunday': '',
  'departures-to-thursday': '',
  'departures-to-tuesday': '',
  'departures-to-wednesday': '',
  'domestic-from-friday': '',
  'domestic-from-monday': '',
  'domestic-from-saturday': '',
  'domestic-from-sunday': '',
  'domestic-from-thursday': '',
  'domestic-from-tuesday': '',
  'domestic-from-wednesday': '',
  'domestic-to-friday': '',
  'domestic-to-monday': '',
  'domestic-to-saturday': '',
  'domestic-to-sunday': '',
  'domestic-to-thursday': '',
  'domestic-to-tuesday': '',
  'domestic-to-wednesday': '',
  'h24-arrival': false,
  'h24-departures': false,
  'h24-domestic': false,
  'onRequest-arrival': false,
  'onRequest-departures': false,
  'onRequest-domestic': false,
  'rmks-arrival': '',
  'rmks-departures': '',
  'rmks-domestic': '',
};
